import { graphql } from "@/gql";

export const MEMBERS_QUERY = graphql(`
  query MEMBERS_QUERY($organizationId: String!) {
    organization(id: $organizationId) {
      id
      memberMetadataFields
      groups {
        nodes {
          id
          organizationId
          name
          description
          members {
            nodes {
              id
              fullName
              displayName
              avatarUrl
              isEnabled
            }
          }
        }
      }
      invitations {
        nodes {
          id
          organizationId
          key
          organizationRole
          groupIds
          metadata
        }
      }
      membershipRequests {
        nodes {
          id
          organizationId
          createdAt
          fullName
          avatarUrl
          phoneNumber
          emailAddress
          membershipCode {
            id
            organizationRole
          }
        }
      }
      members {
        nodes {
          id
          organizationId
          createdAt
          fullName
          displayName
          avatarUrl
          organizationRole
          lastActiveAt
          isEnabled
          emailAddress
          phoneNumber
          updatedAt
        }
      }
    }
  }
`);
